import api from "./axios";
import type { Member } from "@/types";

export const getMembers = () =>
  api.get<Member[]>("/members").then((r) => r.data);
export const getMember = (id: string) =>
  api.get<Member>(`/members/${id}`).then((r) => r.data);
export const createMember = (data: Partial<Member>) =>
  api.post<Member>("/members", data).then((r) => r.data);
export const updateMember = (id: string, data: Partial<Member>) =>
  api.patch<Member>(`/members/${id}`, data).then((r) => r.data);
export const deleteMember = (id: string) => api.delete(`/members/${id}`);

export const assignMembership = (
  memberId: string,
  membershipId: string,
  data: { activeFrom: string; activeThrough?: string },
) =>
  api
    .post<Member>(`/members/${memberId}/memberships`, {
      membershipId,
      ...data,
    })
    .then((r) => r.data);
export const removeMembership = (memberId: string, membershipId: string) =>
  api.delete(`/members/${memberId}/memberships/${membershipId}`);
